import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  triggerShowHeader,
  unsetPayoutDashboard,
} from "../../redux/actions/action";
import { mapTokenToRoleId } from "../../utils/common/index";
import {
  commonActionDispatcher,
  triggerFetchAllEndPoints,
  triggerFetchTimeStamp,
  triggerJCAreaFilter,
} from "../../redux/actions/index";
import RetailerPerformanceViews from "../../views/retailerPerformance";
import { triggerIsDashboardAccessible } from "../../redux/actions";
import config from "../../utils/config";

const RetailerPerformance = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [showAlert, setShowAlert] = useState(null);
  const [dashboardName, setDashboardName] = useState("Retailer Performance");
  const [searchFields, setSearchFields] = useState({});
  const [distList, setDistList] = useState({
    loading: false,
    data: null,
    error: null,
  });

  const handleChange = (event, newValue) => {
    setSelectedTab(event);
  };

  const {
    getAllAPI,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    timestamp,
    tilesData,
    partnerRoleType,
    filteredArray,
  } = useSelector((state) => state.homeReducer);

  const { selectedState, selectedRegion, partnerName, site, selectedArea } =
    filterValue;

  const { dashboardAccessibility } = useSelector(
    (state) => state?.dashboardAccessibilityReducer
  );

  const { data, loading } = getAllAPI;

  const dispatch = useDispatch();

  const { content: hierarchy } = data;

  const moduleName = hierarchy
    ? hierarchy.filter(
        (item) => item?.moduleName?.toLowerCase() === "retailer performance"
      )[0]?.moduleName
    : "";

  let timeStampObj = {
    headers: {
      "Content-Type": "application/json",
    },
    params: {
      moduleName: moduleName,
      partnerRole: searchFields?.partner?.partnerRoleType ?? partnerRoleType,
    },
  };

  let timestampArr = null;
  if (timestamp && timestamp.data && timestamp.data[moduleName]) {
    timestampArr = timestamp.data[moduleName][moduleName];
  }

  const onRunClick = (searchFields) => {
    const obj = {
      role:
        searchFields?.partner?.partnerRoleType ??
        (["jpm"]?.includes(partnerName?.toLowerCase())
          ? partnerRoleType
          : mapTokenToRoleId(searchFields?.partner?.split("-")?.[0])),
      roleType: partnerName?.toUpperCase(),
      partnerRoleType: partnerName,
      forTiles: "NO",
      site: site,
    };
    dispatch(
      triggerFetchAllEndPoints(obj, (err) => {
        // ERROR CALLBACK
      })
    );
  };

  const getAllPartnersList = useCallback(() => {
    if (searchFields?.state) {
      const distListDto = {
        headers: {
          "Content-Type": "application/json",
        },
        type: "POST",
        url: `${config.apiBasePath.baseIp}filterDistList`,
        params: {
          state: searchFields?.state,
        },
        callback: (res) => {
          setDistList({
            loading: false,
            data: res.content,
            error: null,
          });
          setSearchFields((prev) => {
            return { ...prev, partner: res.content[0] };
          });
        },
        errCallback: (err) => {
          setDistList({
            loading: false,
            data: [],
            error: err.data,
          });
        },
      };
      setDistList({
        loading: true,
        data: [],
        error: null,
      });
      dispatch(commonActionDispatcher(distListDto));
    }
  }, [dispatch, searchFields?.state]);

  const fetchJCArea = useCallback(() => {
    setDistList({
      loading: true,
      data: null,
      error: null,
    });
    let obj = {
      params: {
        areaJcFlag: "JC",
        id: searchFields?.jc ?? selectedArea,
        jpFlag: "JC",
      },
    };
    const callback = (res) => {
      setDistList({
        loading: false,
        data: res?.content,
        error: null,
      });
      setSearchFields((prev) => ({
        ...prev,
        partner: res?.content?.[0],
      }));
    };
    dispatch(triggerJCAreaFilter(obj, "JC", callback));
  }, [dispatch, searchFields?.jc]);

  useEffect(() => {
    if (["jc", "area"]?.includes(partnerName?.toLowerCase())) {
      setDistList({
        loading: false,
        data: filteredArray?.["RDS/ARD/MARD"] ?? [],
        error: null,
      });
    } else if (partnerName?.toLowerCase()?.includes("jpm")) {
      setDistList({
        loading: false,
        data: filteredArray?.["All/JP"]?.slice(1) ?? [],
        error: null,
      });
    }
  }, [filteredArray, partnerName]);

  useEffect(() => {
    setSearchFields({
      region: selectedRegion ? selectedRegion : config?.region[0],
      state: selectedState
        ? selectedState
        : config?.states?.[
            config?.regionMaps?.[
              selectedRegion
                ? selectedRegion
                : config?.region?.[0]?.toUpperCase()
            ]
          ]?.[0],
    });
  }, []);

  useEffect(() => {
    if (partnerName?.toLowerCase()?.includes("area")) {
      setSearchFields((prev) => ({
        ...prev,
        partner: filteredArray?.["RDS/ARD/MARD"]?.[0],
      }));
    }
  }, []);

  useEffect(() => {
    if (searchFields?.jc && filteredArray?.["JC"]?.length !== 0) {
      fetchJCArea();
    }
  }, [fetchJCArea, searchFields?.jc]);

  useEffect(() => {
    if (
      ["nhq", "region head", "state head"].includes(partnerName.toLowerCase())
    )
      getAllPartnersList();
    else {
      if (partnerName?.toLowerCase()?.includes("jpm")) {
        setSearchFields((prev) => ({
          ...prev,
          partner: filteredArray?.["All/JP"]?.[1],
        }));
      } else if (partnerName?.toLowerCase()?.includes("area")) {
        setSearchFields((prev) => ({
          ...prev,
          jc: filteredArray?.["JC"]?.[0],
        }));
      } else {
        setSearchFields((prev) => ({
          ...prev,
          partner: filteredArray?.["RDS/ARD/MARD"]?.[0],
        }));
      }
    }
  }, [getAllPartnersList]);
  console.log("searchFields", searchFields);

  useEffect(() => {
    const fetchData = () => {
      return dispatch(triggerShowHeader(true));
    };

    const unsetPayoutDashboardForCalender = () => {
      return dispatch(unsetPayoutDashboard());
    };
    unsetPayoutDashboardForCalender();

    function fetchTimeStamp() {
      return dispatch(triggerFetchTimeStamp(timeStampObj, moduleName));
    }

    //check if isTestingActive is true, then send api call for triggerIsDashboardAccessible
    let isTestingActive = tilesData?.data?.content?.filter(
      (obj) => obj.moduleName === dashboardName
    )[0].isTestingActive;

    //if it is true, then check if this loggedin user has access to this dashboard
    if (isTestingActive) {
      //to check if the response for this dashboard api call is already cached in redux
      let isExistingDashboard = dashboardAccessibility?.data?.filter(
        (currentDashboard) => currentDashboard.dashboard === dashboardName
      );

      //if dashboard accessibility is already cached and accessEnabled is false, means directly show alert without sending api call again
      if (
        isExistingDashboard.length > 0 &&
        !isExistingDashboard[0]?.isDashboardAccessible?.accessEnabled
      ) {
        // load dashboardcard home component and show alert
        return setShowAlert(true);
      }

      // if dashboard accessibility is cached and accessEnabled is true, do not send api call, do not show alert BUT SHOW DASHBOARD NORMALLY
      else if (
        isExistingDashboard.length > 0 &&
        isExistingDashboard[0]?.isDashboardAccessible?.accessEnabled
      ) {
        setShowAlert(false);

        if (
          getAllAPI &&
          getAllAPI.data &&
          getAllAPI.data.content &&
          getAllAPI.data.content[0]
        ) {
          fetchTimeStamp();
        }
        fetchData();
      }

      //if dashboard accessibility is not cached already then send api call for this dashboard
      else {
        const data = {
          baseParameter: {
            name: dashboardName,
            userType: filterValue.site,
          },
          domainId:
            filterValue.orgId !== "" ? filterValue.orgId : filterValue?.agentId,
        };

        const obj = {
          headers: {
            "Content-Type": "application/json",
            url: "get-dashboard-user-role-mapping",
          },
          params: data,
          extraData: "get-dashboard-user-role-mapping",
        };

        return dispatch(
          triggerIsDashboardAccessible(obj, (res) => {
            //if the response shows access enabled as false, go to home page and show alert
            if (!res.content.accessEnabled) {
              setShowAlert(true);
            } else {
              setShowAlert(false);

              if (
                getAllAPI &&
                getAllAPI.data &&
                getAllAPI.data.content &&
                getAllAPI.data.content[0]
              ) {
                fetchTimeStamp();
              }
              fetchData();
            }
          })
        );
      }
    }

    //if isTestingActive is false, it is open for all users
    else {
      setShowAlert(false);

      if (
        getAllAPI &&
        getAllAPI.data &&
        getAllAPI.data.content &&
        getAllAPI.data.content[0]
      ) {
        fetchTimeStamp();
      }
      fetchData();
    }
  }, [getAllAPI]);

  return (
    <RetailerPerformanceViews
      data={data}
      hierarchy={hierarchy}
      handleChange={handleChange}
      selectedTab={selectedTab}
      moduleName={moduleName}
      filterValue={filterValue}
      headerSelectedDateFrom={headerSelectedDateFrom}
      headerSelectedDateTo={headerSelectedDateTo}
      timestampArr={timestampArr}
      partnerName={partnerName}
      searchFields={searchFields}
      setSearchFields={setSearchFields}
      distList={distList}
      onRunClick={onRunClick}
      loading={loading}
      filteredArray={filteredArray}
      partnerRoleType={partnerRoleType}
    />
  );
};

export default RetailerPerformance;
